import JQuery from "jquery";

class AtlasIcon {
  private readonly iconContainer: JQuery<HTMLElement>;
  private readonly iconPosition: { x: number; y: number };
  private readonly iconDimension: { w: number; h: number };

  /**
   *
   * @param iconContainer - The div which represents the icon. *MUST* have an img child (which should the class asset-icon)
   * @param h - height - extracted from the atlas json
   * @param w - width - extracted from the atlas json
   * @param x - x position (within the atlas image)- extracted from the atlas json
   * @param y - y position (within the atlas image)- extracted from the atlas json
   * @param sourceImg
   * @constructor
   */
  constructor(
    iconContainer: JQuery<HTMLElement>,
    sourceImg: string,
    h: number,
    w: number,
    x: number,
    y: number,
  ) {
    this.iconContainer = iconContainer;
    this.iconPosition = { x, y };
    this.iconDimension = { w, h };
    const icon = iconContainer.find(".icon");
    const iconLoader = iconContainer.find(".icon-loader");
    icon.attr("src", sourceImg);
    iconLoader.addClass("hide");
    icon.removeClass("hide");
    this.AdjustAtlasToFit(
      this.iconContainer.parent().width(),
      this.iconContainer.parent().height(),
    );
  }

  /**
   * This function adjust the icon and its atlas to best fit into a specific container size.
   * @param containerWidth
   * @param containerHeight
   * @param shrinkPercentage Allows for some padding inside the container
   */
  public AdjustAtlasToFit(
    containerWidth = 70,
    containerHeight = 70,
    shrinkPercentage = 75,
  ): void {
    const expectedWidth = (containerWidth * shrinkPercentage) / 100;
    const expectedHeight = (containerHeight * shrinkPercentage) / 100;
    const icon = this.iconContainer.find("img");

    //Rescale larger image, so it fits within container by width and height
    let bestRatio = Math.min(
      expectedWidth / this.iconDimension.w,
      expectedHeight / this.iconDimension.h,
    );

    //Adjust for better pixel perfect for smaller assets
    if (
      this.iconDimension.w * 2 <= expectedWidth &&
      this.iconDimension.h * 2 <= expectedHeight
    ) {
      bestRatio = 2;
    }

    const imageDimension = {
      width: this.iconDimension.w * bestRatio,
      height: this.iconDimension.h * bestRatio,
    };

    const spaceAroundImage = {
      left: (expectedWidth - imageDimension.width) / 2,
      top: (expectedHeight - imageDimension.height) / 2,
    };

    const imageCenter = {
      x: this.iconPosition.x + this.iconDimension.w / 2,
      y: this.iconPosition.y + this.iconDimension.h / 2,
    };

    const imageTranslation = {
      x: -imageCenter.x * bestRatio - spaceAroundImage.left,
      y: -imageCenter.y * bestRatio - spaceAroundImage.top,
    };

    const imagePosition = {
      left: expectedWidth / 2,
      top: expectedHeight / 2,
      transformOrigin: "0 0",
      transform: `translate(${imageTranslation.x}px,${imageTranslation.y}px) scale(${bestRatio})`,
    };

    this.iconContainer.css(imageDimension);
    icon.css(imagePosition);
  }
}

export default AtlasIcon;
